export enum FacialRecognitionPref {
	AVAILABLE = 'faces.available',
	CONFIDENCE_THRESHOLD = 'faces.confidence',
	ENABLED = 'faces.enabled',
	MAX_FACES = 'faces.maxFaces',
}
